import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  AppDispatch,
  fullstorySelectors,
  PagesRequestActions,
  pagesSelectors,
} from '@fullstory/redux';

const { getPagesRequestState, pagesById, pagesByIdWithPageDefZero } = pagesSelectors;

export const usePages = (includePageDefZero: boolean = false) => {
  const orgId = useSelector(fullstorySelectors.getOrgId);
  const dispatch = useDispatch<AppDispatch>();

  // Get pages state
  const state = useSelector(getPagesRequestState);
  const pages = useSelector(pagesById);
  const pagesWithPageDefZero = useSelector(pagesByIdWithPageDefZero);

  const fetchPages = React.useCallback(
    (force: boolean) => {
      if (orgId) {
        dispatch(PagesRequestActions.getAllPages(orgId, force));
      }
    },
    [orgId, dispatch],
  );

  // Dispatch initial get request
  React.useEffect(() => fetchPages(false), [fetchPages]);

  return {
    ...state,
    isReady: !state.loading && !state.error && state.lastRequested > -1,
    pages: includePageDefZero ? pagesWithPageDefZero : pages,
    fetchPages,
  };
};
